const SampleTypeEnum = Object.freeze([
    { id: 1, name: "Skjellprøve" },
    { id: 2, name: "Prøve på sprit" },
    { id: 3, name: "Otolitt" },
    { id: 4, name: "PIT-nål" },
    { id: 5, name: "Skjellprøve og otolitt" }
 ]);
  
  export default SampleTypeEnum;